export default __webpack_public_path__ + "static/media/2FVISUAL_logo.c628dcda.png";